import { render, staticRenderFns } from "./DiscoverySave.vue?vue&type=template&id=3d2af7de"
import script from "./DiscoverySave.vue?vue&type=script&lang=js"
export * from "./DiscoverySave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports